import { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

const Slide = ({ children }: PropsWithChildren) => <div>{children}</div>;

export default styled(Slide)``;
